import { Download, FileText, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

// Shows a PDF blob URL on screen with a download button.
export const PdfDialog = ({ url, title, filename, onClose, testid = "pdf-viewer" }) => (
  <Dialog open={!!url} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-4xl w-[96vw] h-[90vh] p-0 gap-0 flex flex-col overflow-hidden [&>button]:hidden" data-testid={testid}>
      <div className="flex items-center justify-between px-4 h-14 border-b border-slate-200 shrink-0">
        <DialogTitle className="font-display font-extrabold text-slate-900 flex items-center gap-2"><FileText className="h-5 w-5 text-blue-700" />{title}</DialogTitle>
        <div className="flex items-center gap-2">
          <a href={url || undefined} download={filename} data-testid={`${testid}-download`}
            className="h-9 px-3 rounded-full border border-slate-300 text-sm font-semibold text-slate-700 hover:border-blue-500 flex items-center gap-1.5 transition-colors"><Download className="h-4 w-4" /><span className="hidden sm:inline">Download PDF</span></a>
          <button onClick={onClose} aria-label="Close" data-testid={`${testid}-close`} className="h-9 w-9 rounded-full hover:bg-slate-100 flex items-center justify-center transition-colors"><X className="h-5 w-5" /></button>
        </div>
      </div>
      {url && <iframe src={url} title={title} className="flex-1 w-full bg-slate-100" data-testid={`${testid}-frame`} />}
    </DialogContent>
  </Dialog>
);
